import {useIsDesktop} from '@eCommerce/frontend-legacy-shared-library-native';
import {Text, View} from 'native-base';
import React from 'react';

import {GatedModulePropTypes} from '..';
import GatedProfilePanel from '../GatedProfilePanel';
import {useTheme} from 'styled-components/native';

const GatedPaymentsModule: React.FC<GatedModulePropTypes> = ({
  mfaOptinStatus,
  onPrimaryPress,
  isLoading,
}) => {
  const isDesktop = useIsDesktop();
  const theme = useTheme();
  const {paleSky} = theme.colors;

  return (
    <GatedProfilePanel
      isLoading={isLoading}
      panelTitle="Saved Payment Methods"
      iconName="credit-card"
      contentHeight={680}
      onPrimaryPress={onPrimaryPress}
      mfaOptinStatus={mfaOptinStatus}
      testID="payments">
      <Text
        color={paleSky}
        fontFamily="body"
        fontSize="16px"
        lineHeight="26px"
        marginBottom="48px">
        For your security, two-factor verification is required to view, add, or
        remove payment information.
      </Text>
      <View
        borderWidth="1px"
        borderColor="rgba(112,119,132,0.3)"
        borderRadius="16px"
        padding="24px"
        width={isDesktop ? '320px' : '280px'}
        height="180px"
        justifyContent="space-between"
        alignSelf={isDesktop ? undefined : 'center'}>
        <Text color={paleSky} fontSize="14px" letterSpacing="2px">
          •••• •••• •••• ••••
        </Text>
        <View>
          <Text color={paleSky} fontSize="12px" marginBottom="8px">
            ••••••••••••
          </Text>
          <View flexDirection="row" justifyContent="space-between">
            <Text color={paleSky} fontSize="12px">
              ••/••
            </Text>
          </View>
        </View>
      </View>
    </GatedProfilePanel>
  );
};

export default GatedPaymentsModule;
